import { render, staticRenderFns } from "./InsurerTrackersList.vue?vue&type=template&id=789db0eb"
import script from "./InsurerTrackersList.vue?vue&type=script&lang=js"
export * from "./InsurerTrackersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports